var _g, _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLiving(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 60.532,
    viewBox: "0 0 290.525 107.532",
    className: "",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_282",
    "data-name": "Grupo 282",
    transform: "translate(-814.237 -9264.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_203",
    "data-name": "Grupo 203",
    transform: "translate(4001 9426.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_174",
    "data-name": "Grupo 174",
    transform: "translate(-3186 -111.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1257",
    "data-name": "Caminho 1257",
    d: "M641.044,74.292c.361,0,.521.22.521.621v54.08h38.517c.4,0,.621.18.621.561s-.22.561-.621.561H641.044a.541.541,0,0,1-.6-.6v-54.6a.541.541,0,0,1,.6-.621Z",
    transform: "translate(-640.437 -74.28)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.52,
    className: "aKZlitSL_0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1258",
    "data-name": "Caminho 1258",
    d: "M671.2,74.913a.541.541,0,0,1,.6-.621c.361,0,.541.22.541.621v54.621a.521.521,0,0,1-.581.6c-.381,0-.561-.2-.561-.6Z",
    transform: "translate(-609.585 -74.28)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.52,
    className: "aKZlitSL_1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1259",
    "data-name": "Caminho 1259",
    d: "M706.423,130.134a.581.581,0,0,1-.541-.34l-23.354-54.7a.283.283,0,0,1,0-.18.6.6,0,0,1,1.142-.26l22.854,53.379,22.834-53.379a.579.579,0,0,1,1.122.26.24.24,0,0,1,0,.18l-23.455,54.7A.641.641,0,0,1,706.423,130.134Z",
    transform: "translate(-598.237 -74.28)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.52,
    className: "aKZlitSL_2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1260",
    "data-name": "Caminho 1260",
    d: "M717.133,74.913a.541.541,0,0,1,.6-.621c.34,0,.521.22.521.621v54.621c0,.4-.18.6-.561.6s-.561-.2-.561-.6Z",
    transform: "translate(-563.52 -74.28)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.52,
    className: "aKZlitSL_3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1261",
    "data-name": "Caminho 1261",
    d: "M769.612,74.294a.561.561,0,0,1,.621.621v54.621c0,.4-.2.6-.621.6a.581.581,0,0,1-.521-.26L731.035,76.757v52.778a.521.521,0,0,1-.581.6c-.38,0-.561-.2-.561-.6V74.914a.541.541,0,0,1,.6-.621.521.521,0,0,1,.441.28l38.056,53.118V74.914a.541.541,0,0,1,.621-.621Z",
    transform: "translate(-550.722 -74.282)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.52,
    className: "aKZlitSL_4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1262",
    "data-name": "Caminho 1262",
    d: "M788.874,74.3a27.06,27.06,0,0,1,20.03,8.012.581.581,0,0,1,.18.441.541.541,0,0,1-.6.621.561.561,0,0,1-.441-.18,26.824,26.824,0,1,0-.18,38.337V102.838h-26.78c-.4,0-.6-.2-.6-.621a.541.541,0,0,1,.6-.6H808.4a.541.541,0,0,1,.6.6v19.569a.58.58,0,0,1-.18.441,28.2,28.2,0,1,1-20.029-47.891Z",
    transform: "translate(-520.09 -74.284)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.52,
    className: "aKZlitSL_5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_176",
    "data-name": "Grupo 176",
    transform: "translate(-3183.93 -161.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1263",
    "data-name": "Caminho 1263",
    d: "M719.581,54.223h4.106a6.93,6.93,0,0,1,2.844.481,2.444,2.444,0,0,1,1.5,2.4,2.624,2.624,0,0,1-1.5,2.5,4.168,4.168,0,0,1-1.222.4,5.129,5.129,0,0,1,1.562.481,3.285,3.285,0,0,1,0,5.668,6.009,6.009,0,0,1-2.9.6h-4.387a.1.1,0,0,1-.12-.12s0-.14.12-.14h4.387a6.008,6.008,0,0,0,2.8-.561,3.079,3.079,0,0,0,.02-5.228,6.209,6.209,0,0,0-2.824-.541h-4.386a.12.12,0,1,1,0-.24h4.106a6.009,6.009,0,0,0,2.724-.541,2.4,2.4,0,0,0,1.4-2.283,2.244,2.244,0,0,0-1.382-2.183,6.892,6.892,0,0,0-2.744-.441h-4.106a.125.125,0,0,1-.12-.14.1.1,0,0,1,.12-.12Z",
    transform: "translate(-563.25 -44.89)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1264",
    "data-name": "Caminho 1264",
    d: "M736.7,54.22a.137.137,0,0,1,.14.14l-5.248,6.67v5.508h0a.1.1,0,0,1-.12.12c-.1,0-.14,0-.14-.12h0V61.11L726,54.44h0a.137.137,0,0,1,.14-.14l5.168,6.57,5.148-6.57A1.672,1.672,0,0,1,736.7,54.22Z",
    transform: "translate(-556.69 -44.887)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1265",
    "data-name": "Caminho 1265",
    d: "M747.128,54a6.234,6.234,0,0,1,3.946,11.217l2.283,2v.1c0,.1,0,.14-.12.14h0l-2.323-2a6.369,6.369,0,0,1-3.725,1.162,6.01,6.01,0,0,1-3.165-.841,5.827,5.827,0,0,1-2.183-2.283,6.729,6.729,0,0,1,0-6.289,5.828,5.828,0,0,1,2.183-2.283,6.01,6.01,0,0,1,3.1-.921Zm0,.26A5.528,5.528,0,0,0,742.942,56a6.331,6.331,0,0,0,0,8.553,5.548,5.548,0,0,0,4.206,1.743,6.009,6.009,0,0,0,3.505-1.082l-3.585-3.085h0s0-.14.12-.14h0l3.765,3.065a5.827,5.827,0,0,0,1.783-2.1,5.606,5.606,0,0,0,.661-2.684,5.768,5.768,0,0,0-1.8-4.266,6.009,6.009,0,0,0-4.466-1.743Z",
    transform: "translate(-541.585 -45.108)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1266",
    "data-name": "Caminho 1266",
    d: "M749.5,54.221s.1,0,.1.14v7.431a4.647,4.647,0,0,0,9.294,0V54.361a.137.137,0,0,1,.14-.14.12.12,0,0,1,.14.14v7.431a4.727,4.727,0,0,1-1.442,3.465,4.907,4.907,0,0,1-8.372-3.465V54.361S749.4,54.221,749.5,54.221Z",
    transform: "translate(-533.261 -44.888)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1268",
    "data-name": "Caminho 1268",
    d: "M764.27,54.232h1.683a7.692,7.692,0,0,1,5.568,1.783,7.15,7.15,0,0,1,0,8.973,7.691,7.691,0,0,1-5.568,1.783H764.19s-.141,0-.141-.12a.14.14,0,0,1,.141-.14h1.762a7.211,7.211,0,0,0,5.368-1.723,6.87,6.87,0,0,0,0-8.573,7.212,7.212,0,0,0-5.368-1.723H764.19a.14.14,0,0,1-.141-.14S764.19,54.232,764.27,54.232Z",
    transform: "translate(-518.527 -44.899)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1269",
    "data-name": "Caminho 1269",
    d: "M771.4,54.222h4.387a6.009,6.009,0,0,1,2.9.641,2.965,2.965,0,0,1,1.623,2.764,2.924,2.924,0,0,1-1.543,2.764,5.566,5.566,0,0,1-2,.6l4.387,5.548h0s0,.14-.12.14a.12.12,0,0,1-.12,0l-4.467-5.668H771.5V66.56c0,.1,0,.14-.14.14s-.12,0-.12-.14V60.932a.125.125,0,0,1,.14-.12h4.867l-4.987-6.329S771.3,54.222,771.4,54.222Zm.26.26,4.927,6.269a5.264,5.264,0,0,0,2-.6,2.9,2.9,0,0,0,0-5.047,5.669,5.669,0,0,0-2.784-.621Z",
    transform: "translate(-511.316 -44.889)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1270",
    "data-name": "Caminho 1270",
    d: "M783.708,54.24a.14.14,0,0,1,.14,0L789.1,66.518h0c0,.1,0,.14-.14.14a.1.1,0,0,1-.12,0l-5.148-12.018L778.56,66.658a.14.14,0,0,1-.12,0c-.1,0-.14,0-.14-.14h0l5.248-12.278a.1.1,0,0,1,.16,0Z",
    transform: "translate(-504.235 -44.907)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1564",
    "data-name": "Caminho 1564",
    d: "M783.708,54.24a.14.14,0,0,1,.14,0L789.1,66.518h0c0,.1,0,.14-.14.14a.1.1,0,0,1-.12,0l-5.148-12.018L778.56,66.658a.14.14,0,0,1-.12,0c-.1,0-.14,0-.14-.14h0l5.248-12.278a.1.1,0,0,1,.16,0Z",
    transform: "translate(-547.8 -44.782)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_175",
    "data-name": "Grupo 175",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1271",
    "data-name": "Caminho 1271",
    d: "M641.63,53.87a.125.125,0,0,1,.12.14V67.53h9.614c.1,0,.16,0,.16.14a.14.14,0,0,1-.16.14H641.63c-.12,0-.16,0-.16-.16V54.01S641.51,53.87,641.63,53.87Z",
    transform: "translate(-641.47 -45.238)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1272",
    "data-name": "Caminho 1272",
    d: "M648.91,53.87a.137.137,0,0,1,.14.14v8.352a5.168,5.168,0,1,0,10.315,0V54.01a.144.144,0,0,1,.16-.14c.16,0,.14,0,.14.14v8.352a5.229,5.229,0,0,1-1.582,3.846,5.468,5.468,0,0,1-7.731,0,5.228,5.228,0,0,1-1.582-3.846V54.01S648.81,53.87,648.91,53.87Z",
    transform: "translate(-634.149 -45.238)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1273",
    "data-name": "Caminho 1273",
    d: "M657.313,53.877l5.248,6.67,5.248-6.67a.1.1,0,0,1,.1,0h0a.144.144,0,0,1,.14.16h0l-5.208,6.81,5.288,6.73h0s0,.16-.14.16a.12.12,0,0,1-.12,0l-5.248-6.67-5.248,6.67c-.12,0-.16,0-.16-.16l5.308-6.73-5.348-6.71C657.152,53.937,657.192,53.877,657.313,53.877Z",
    transform: "translate(-625.726 -45.245)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1274",
    "data-name": "Caminho 1274",
    d: "M670.082,54.01h1.883a8.292,8.292,0,0,1,6.009,2,7.752,7.752,0,0,1,0,9.694,8.292,8.292,0,0,1-6.009,2h-1.883s-.16,0-.16-.14,0-.12.16-.12h1.883a8.012,8.012,0,0,0,5.828-1.883,6.269,6.269,0,0,0,1.6-4.627,6.329,6.329,0,0,0-1.6-4.627,8.012,8.012,0,0,0-5.828-1.863h-1.883a.14.14,0,0,1-.16-.14C669.9,54.01,669.962,54.01,670.082,54.01Z",
    transform: "translate(-612.938 -45.118)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1275",
    "data-name": "Caminho 1275",
    d: "M677.8,54h9.474a.137.137,0,0,1,.14.14.12.12,0,0,1-.14.14H677.8a.14.14,0,0,1-.16-.14C677.64,54,677.7,54,677.8,54Zm0,6.63h8.573a.137.137,0,0,1,.14.14c0,.14,0,.16-.14.16H677.86a.14.14,0,0,1-.16-.16s0-.24.1-.24Zm0,6.65h9.474s.14,0,.14.12,0,.14-.14.14H677.8c-.1,0-.16,0-.16-.14s.06-.22.16-.22Z",
    transform: "translate(-605.193 -45.108)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1276",
    "data-name": "Caminho 1276",
    d: "M691.286,54a9.4,9.4,0,0,1,3.125.481,5.869,5.869,0,0,1,2.2,1.282.161.161,0,0,1,0,.1s0,.14-.12.14a.14.14,0,0,1-.12,0,6.168,6.168,0,0,0-2-1.2,8.893,8.893,0,0,0-3.025-.461,7.271,7.271,0,0,0-4.246,1.122,3.466,3.466,0,0,0-1.082,1.082,2.306,2.306,0,0,0-.361,1.182,1.742,1.742,0,0,0,.441,1.182,3.506,3.506,0,0,0,1.222.821,22.635,22.635,0,0,0,3.886.981,19.465,19.465,0,0,1,4.006,1.021,3.446,3.446,0,0,1,1.342.861,1.882,1.882,0,0,1,.541,1.342,3.145,3.145,0,0,1-1.843,2.724,8.191,8.191,0,0,1-4.006.941,10.015,10.015,0,0,1-6.009-1.8.1.1,0,0,1,0-.1.137.137,0,0,1,.14-.14h.1a9.614,9.614,0,0,0,5.889,1.763,7.531,7.531,0,0,0,3.826-.941,2.885,2.885,0,0,0,1.723-2.464,1.623,1.623,0,0,0-.461-1.142,3.346,3.346,0,0,0-1.242-.821,21.611,21.611,0,0,0-3.886-.961,23.817,23.817,0,0,1-4.006-1.021,3.726,3.726,0,0,1-1.342-.9,2,2,0,0,1-.521-1.362,2.6,2.6,0,0,1,.4-1.322,4.629,4.629,0,0,1,1.162-1.182A7.792,7.792,0,0,1,691.286,54Z",
    transform: "translate(-597.587 -45.108)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1277",
    "data-name": "Caminho 1277",
    d: "M693.93,54.07c0-.1,0-.14.14-.14s.14,0,.14.14V67.33a.12.12,0,0,1-.14.14.137.137,0,0,1-.14-.14Z",
    transform: "translate(-588.855 -45.178)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1278",
    "data-name": "Caminho 1278",
    d: "M703.46,54.06a6.61,6.61,0,0,1,4.847,2,.277.277,0,0,1,0,.12c0,.1,0,.14-.16.14h0a6.289,6.289,0,0,0-4.627-1.863,6.51,6.51,0,1,0,0,13,6.289,6.289,0,0,0,4.586-1.843V60.89h-6.55c-.1,0-.14,0-.14-.16s0-.14.14-.14h6.63c.1,0,.16,0,.16.14v4.747h0a6.61,6.61,0,0,1-4.847,2,6.77,6.77,0,1,1,0-13.54Z",
    transform: "translate(-586.127 -45.168)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1279",
    "data-name": "Caminho 1279",
    d: "M714.954,54.075c.1,0,.16,0,.16.14v13.26a.144.144,0,0,1-.16.14.12.12,0,0,1-.12,0L705.62,54.736v12.8a.12.12,0,0,1-.14.14.137.137,0,0,1-.14-.14V54.075c0-.1,0-.14.14-.14a.18.18,0,0,1,.12,0l9.214,12.9V54.075Z",
    transform: "translate(-577.411 -45.183)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1280",
    "data-name": "Caminho 1280",
    d: "M678.041,49.82c.18-.22.32-.3.4-.24s0,.2-.18.421L654.146,80.485c-.18.22-.3.3-.381.24s0-.2.16-.421Z",
    transform: "translate(-629.169 -49.56)",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    className: "aKZlitSL_23"
  })))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    "data-made-with": "vivus-instant"
  }, ".aKZlitSL_0{stroke-dasharray:192 194;stroke-dashoffset:193;animation:aKZlitSL_draw_0 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_1{stroke-dasharray:114 116;stroke-dashoffset:115;animation:aKZlitSL_draw_1 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_2{stroke-dasharray:241 243;stroke-dashoffset:242;animation:aKZlitSL_draw_2 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_3{stroke-dasharray:114 116;stroke-dashoffset:115;animation:aKZlitSL_draw_3 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_4{stroke-dasharray:353 355;stroke-dashoffset:354;animation:aKZlitSL_draw_4 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_5{stroke-dasharray:358 360;stroke-dashoffset:359;animation:aKZlitSL_draw_5 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_6{stroke-dasharray:72 74;stroke-dashoffset:73;animation:aKZlitSL_draw_6 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_7{stroke-dasharray:46 48;stroke-dashoffset:47;animation:aKZlitSL_draw_7 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_8{stroke-dasharray:94 96;stroke-dashoffset:95;animation:aKZlitSL_draw_8 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_9{stroke-dasharray:61 63;stroke-dashoffset:62;animation:aKZlitSL_draw_9 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_10{stroke-dasharray:51 53;stroke-dashoffset:52;animation:aKZlitSL_draw_10 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_11{stroke-dasharray:85 87;stroke-dashoffset:86;animation:aKZlitSL_draw_11 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_12{stroke-dasharray:54 56;stroke-dashoffset:55;animation:aKZlitSL_draw_12 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_13{stroke-dasharray:54 56;stroke-dashoffset:55;animation:aKZlitSL_draw_13 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_14{stroke-dasharray:48 50;stroke-dashoffset:49;animation:aKZlitSL_draw_14 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_15{stroke-dasharray:69 71;stroke-dashoffset:70;animation:aKZlitSL_draw_15 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_16{stroke-dasharray:70 72;stroke-dashoffset:71;animation:aKZlitSL_draw_16 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_17{stroke-dasharray:55 57;stroke-dashoffset:56;animation:aKZlitSL_draw_17 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_18{stroke-dasharray:59 61;stroke-dashoffset:60;animation:aKZlitSL_draw_18 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_19{stroke-dasharray:83 85;stroke-dashoffset:84;animation:aKZlitSL_draw_19 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_20{stroke-dasharray:28 30;stroke-dashoffset:29;animation:aKZlitSL_draw_20 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_21{stroke-dasharray:88 90;stroke-dashoffset:89;animation:aKZlitSL_draw_21 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_22{stroke-dasharray:86 88;stroke-dashoffset:87;animation:aKZlitSL_draw_22 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}.aKZlitSL_23{stroke-dasharray:80 82;stroke-dashoffset:81;animation:aKZlitSL_draw_23 6800ms linear 0ms infinite,aKZlitSL_fade 6800ms linear 0ms infinite;}@keyframes aKZlitSL_draw{100%{stroke-dashoffset:0;}}@keyframes aKZlitSL_fade{0%{stroke-opacity:1;}85.29411764705883%{stroke-opacity:1;}100%{stroke-opacity:0;}}@keyframes aKZlitSL_draw_0{11.76470588235294%{stroke-dashoffset: 193}41.17647058823529%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_1{12.404092071611254%{stroke-dashoffset: 115}41.81585677749361%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_2{13.043478260869565%{stroke-dashoffset: 242}42.455242966751925%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_3{13.682864450127877%{stroke-dashoffset: 115}43.09462915601023%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_4{14.322250639386189%{stroke-dashoffset: 354}43.734015345268546%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_5{14.961636828644501%{stroke-dashoffset: 359}44.37340153452685%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_6{15.601023017902813%{stroke-dashoffset: 73}45.012787723785166%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_7{16.240409207161125%{stroke-dashoffset: 47}45.65217391304348%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_8{16.879795396419436%{stroke-dashoffset: 95}46.291560102301794%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_9{17.51918158567775%{stroke-dashoffset: 62}46.930946291560105%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_10{18.158567774936063%{stroke-dashoffset: 52}47.57033248081841%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_11{18.797953964194374%{stroke-dashoffset: 86}48.209718670076725%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_12{19.437340153452684%{stroke-dashoffset: 55}48.849104859335036%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_13{20.076726342710998%{stroke-dashoffset: 55}49.48849104859335%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_14{20.71611253196931%{stroke-dashoffset: 49}50.127877237851656%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_15{21.355498721227622%{stroke-dashoffset: 70}50.76726342710997%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_16{21.994884910485936%{stroke-dashoffset: 71}51.406649616368284%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_17{22.634271099744247%{stroke-dashoffset: 56}52.0460358056266%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_18{23.273657289002557%{stroke-dashoffset: 60}52.685421994884905%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_19{23.913043478260867%{stroke-dashoffset: 84}53.32480818414322%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_20{24.552429667519185%{stroke-dashoffset: 29}53.96419437340154%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_21{25.191815856777495%{stroke-dashoffset: 89}54.60358056265985%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_22{25.831202046035806%{stroke-dashoffset: 87}55.24296675191817%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aKZlitSL_draw_23{26.47058823529412%{stroke-dashoffset: 81}55.88235294117647%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLiving);
export default __webpack_public_path__ + "static/media/logo-living.710801451499dd5799a7f926c3987803.svg";
export { ForwardRef as ReactComponent };